import { render, staticRenderFns } from "./MediaField.form-builder.vue?vue&type=template&id=35f9be9e&"
import script from "./MediaField.form-builder.vue?vue&type=script&lang=js&"
export * from "./MediaField.form-builder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports